import ErrorHandler from '@/components/Error/ErrorHandler'
import FaturasPagasView from '@/components/Fatura/FaturasPagasView'
import Footer from '@/components/Footer'
import Loading from '@/components/Loading'
import Logo from '@/components/Logo'
import useAuth from '@/contexts/useAuth'
import useEmpresa from '@/contexts/useEmpresa'
import { getFaturasPagas, type PagedFaturasResponse } from '@/services/fatura'
import type { Fatura } from '@/types/fatura'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams, useSearchParams } from 'react-router-dom'

const PAGE_SIZE = 12

export default function GuestFaturasPagas() {
    const { t } = useTranslation()
    const { clienteHash } = useParams<{ clienteHash: string }>()
    const { user } = useAuth()
    const { empresa } = useEmpresa()
    const [searchParams, setSearchParams] = useSearchParams()
    const page = Math.max(1, Number(searchParams.get('page') ?? 1) || 1)
    const [faturasPage, setFaturasPage] = useState<PagedFaturasResponse<Fatura> | null>(null)
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState<Error | null>(null)

    useEffect(() => {
        if (!user || !clienteHash) return

        let cancelled = false
        ;(async () => {
            setIsLoading(true)
            try {
                const data = await getFaturasPagas(page, PAGE_SIZE, clienteHash)
                if (!cancelled) setFaturasPage(data)
            } catch (err) {
                if (!cancelled) setError(err as Error)
            } finally {
                if (!cancelled) setIsLoading(false)
            }
        })()

        return () => {
            cancelled = true
        }
    }, [page, user, clienteHash])

    const setPage = (nextPage: number) => {
        const params = new URLSearchParams(searchParams)
        params.set('page', String(nextPage))
        setSearchParams(params, { replace: true })
    }

    if (error) return <ErrorHandler error={error} />
    if (!user || !empresa) return <Loading type="primary" />

    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <header>
                <div className="nav-container">
                    <Logo className="logo" />
                </div>
                <div className="right">
                    <div className="hello">
                        <span>{t('Olá')}, </span>
                        <strong>{user.Nome?.split(' ')[0]}</strong>
                    </div>
                </div>
            </header>

            <main style={{ padding: 12, flex: 1 }}>
                <FaturasPagasView
                    faturasPage={faturasPage}
                    isLoading={isLoading}
                    backTo={`/c/${clienteHash}/faturas`}
                    onPageChange={setPage}
                />
            </main>

            <Footer />
        </div>
    )
}
